import React from 'react';
import { Link } from 'react-router-dom';

const MyRequests = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-[24px] font-bold text-white mb-1">Can't Find an EA?</h1>
          <p className="text-[14px] text-on-surface-variant">
            Track your requests for Expert Advisors not currently available in our marketplace catalog.
          </p>
        </div>
        <Link to="/request" className="bg-primary text-[#131418] font-bold px-6 py-3 rounded-full text-[14px] hover:shadow-[0_0_15px_rgba(240,185,11,0.4)] hover:-translate-y-0.5 transition-all duration-300 whitespace-nowrap">
          Request a Missing EA
        </Link>
      </div>

      <div className="bg-surface-container border border-white/5 rounded-3xl p-16 text-center flex flex-col items-center justify-center shadow-lg">
        <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-6 border border-white/10">
          <span className="material-symbols-outlined text-[32px] text-[#20b2aa]">move_to_inbox</span>
        </div>
        
        <h2 className="text-[20px] font-bold text-white mb-2">No Missing EA Requests Yet</h2>
        <p className="text-[14px] text-on-surface-variant mb-8 max-w-md">
          Can't find your preferred MT4/MT5 strategy tool? Send us a link and we'll retrieve it at up to 90% OFF.
        </p>
        
        <Link to="/request" className="border border-white/20 text-white font-bold px-8 py-3 rounded-full text-[14px] hover:bg-white/5 hover:border-white/40 transition-all duration-300">
          Request Any EA Now
        </Link>
      </div>
    </div>
  );
};

export default MyRequests;
